import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAddsvcControllerS1Account } from '../generated/endpoint';

type CodeStatus = 'idle' | 'verifying' | 'success' | 'error';

export function useJoinServiceGate() {
  const [searchParams] = useSearchParams();
  // URLSearchParams.get() 은 + 를 공백으로 디코딩하므로 다시 + 로 복원
  const rdCp = useRef(searchParams.get('rd_c_p')?.replace(/ /g, '+') ?? null);
  const code = useRef(searchParams.get('code'));

  const [codeStatus, setCodeStatus] = useState<CodeStatus>(() => (code.current ? 'verifying' : 'idle'));

  const { mutate: verifyCode } = useAddsvcControllerS1Account({
    mutation: {
      onSuccess: (res) => {
        if (res.result === true) {
          setCodeStatus('success');
        } else {
          // TODO: 통합계정에서 실제 로그인한 계정을 확인하지 못한 경우임. 별도 처리 필요없음.
          setCodeStatus('success');
        }
      },
      onError: () => {
        setCodeStatus('error');
      },
    },
  });

  // rd_c_p 가 있으면 바로 access 토큰으로 저장
  useEffect(() => {
    if (rdCp.current) {
      sessionStorage.setItem('access', rdCp.current);
    }
  }, []);

  // code 가 있으면 서버 API로 검증
  useEffect(() => {
    if (!code.current) return;
    verifyCode({ data: { code: code.current } });
  }, [verifyCode]);

  const hasToken = !!(rdCp.current || sessionStorage.getItem('access'));

  return {
    codeStatus,
    hasToken,
  };
}
